module.exports = __webpack_public_path__ + "static/media/piedra.4449bbdf.jpg";